export const isPasswordValid = (password) => {
  // To-do (P2): review password validation
  return password.length >= 8;
};
